module.exports = __webpack_public_path__ + "img/cover_23sei2.8d450978.jpg";